import { render } from "./Msg.vue?vue&type=template&id=fb694648&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"

import "./Msg.vue?vue&type=style&index=0&id=fb694648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb694648"]])

export default __exports__